import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  email: "null",
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    updateEmail: (state, action) => {
      state.email = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateEmail } = authSlice.actions;

export default authSlice.reducer;
